<div class="container">
  @if (this.appType === 'Application') {
  <div class="row">
    <div class="card card-body">
      <section class="container mb-2">
        <div>
          <h1 class="page-title">TennCare Connect Application</h1>
        </div>
        <div>
          <!-- <div *ngIf="!hasPpAccess">
            <p class="mt-2">You haven't been approved to use TennCare Access yet. Contact your Organization Administrator.</p>
            <hr>
            </div> -->
          <div>
            <div class="mt-3">
              <h2 class="section-header">Full Coverage Application</h2>
              <hr />
            </div>
            <div
              class="card m-3 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start mt-2"
            >
              <div
                class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
              >
                <img
                  class="col dot"
                  aria-hidden="true"
                  alt=""
                  src="../../../assets/images/Icons/Welcome_FullCovgApp.svg"
                />
              </div>
              <div class="flex-grow-1 min-w-0 w-100">
                <div
                  tabindex="0"
                  class="section-column"
                  (click)="searchCoverage()"
                >
                  <strong class="tile_header">Apply for Full Coverage</strong>
                  <p>
                    Start an application for TennCare coverage. This includes
                    TennCare and CoverKids. Don’t use this application if you
                    are trying to help someone apply for presumptive eligibility
                    (PE) coverage.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <h2 class="ms-3 section-header">Other Online Forms and Features</h2>
          <hr />
          <div
            class="card m-3 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start mt-2"
          >
            <div
              class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
            >
              <img
                class="col dot"
                aria-hidden="true"
                alt=""
                src="../../../assets/images/Icons/Welcome_SearchSubmissions.svg"
              />
            </div>
            <div class="flex-grow-1 min-w-0 w-100">
              <div
                tabindex="0"
                class="section-column"
                (click)="searchSubmissions()"
              >
                <strong class="tile_header"> Search My Submissions </strong>
                <p>
                  Search for applications you have submitted to review the
                  application summary or upload documents if TennCare has not
                  started working the application yet. You can also search for
                  applications you have started but not finished.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
  } @if (this.appType === 'REDETERMINATION' && isDataLoaded) {
  <div>
    <div class="row mb-2">
      <div class="col-12">
        <h1 class="page-title">Review Renewal Already In Progress</h1>
      </div>
    </div>
    <!-- <nh-alert type="danger" [isOpen]="optionNotSelected">
          <div class="row">
            <div class="col-auto icon">
              <img src="../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg" alt="" />
            </div>
            <div class="col message">
              <span>{{ 'SELECT_TILE' | translate}}</span>
            </div>
          </div>
        </nh-alert> -->
    <!-- <div class="row ps-1 pb-1 hover-red">
        <div class="btn btn-link hover-red" (click)="onPreviousClick()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16.875" height="15.75" viewBox="0 0 16.875 15.75">
            <g id="_icons_arrow-back-outline" data-name="⚛️ icons/arrow-back-outline" transform="translate(0)">
              <path id="Combined_Shape" data-name="Combined Shape"
                d="M7.093,15.434l-.014-.014L.329,8.671A1.126,1.126,0,0,1,.316,7.093l.014-.014L7.079.329a1.125,1.125,0,0,1,1.6,1.578l-.014.013L3.841,6.75H15.75A1.125,1.125,0,0,1,15.769,9H3.841l4.829,4.829a1.126,1.126,0,0,1,.014,1.578l-.014.013a1.126,1.126,0,0,1-1.578.014Z"
                transform="translate(0)" fill="#174a7c" />
              </g>
            </svg>
            <span class="ps-2">{{'BACK_TO_PREVIOUS_PAGE' | translate}}</span>
          </div>
        </div> -->
    <div class="bg-white p-4">
      <h2 class="section-header">In Progress Renewal</h2>
      <hr />
      <p class="static-text">
        From here, you can pick up the renewal where the last call center worker
        left off or start over.
      </p>
      <p class="static-text">
        If any changes were reported since starting the renewal, you may not see
        them here. Be sure to review all the information to make sure it’s
        correct.
      </p>
      <p class="static-text">
        If you start a new renewal, all the information entered before will be
        deleted.
      </p>
      <div>
        <div>
          <div
            class="card card-body shadow mb-2 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start"
            [ngClass]="{ applyColor: selectedValue === 'continue' }"
            (click)="select('continue')"
            role="button"
          >
            <div
              class="mb-3 mb-md-0 me-0 flex-shrink-0 d-flex justify-content-center"
            >
              <img
                class="col dot"
                aria-hidden="true"
                alt=""
                src="../../../assets/images/Icons/Take_back.svg"
              />
            </div>
            <div class="flex-grow-1 min-w-0 w-100">
              <div class="section-column">
                <strong class="tile_header"
                  >Take me back to renewal in progress</strong
                >
                @if (caseDetails) {
                <div>
                  <div class="small tile-margin tile-text">
                    Case Number: {{ caseDetails.caseNumber }}
                  </div>
                  <div class="small tile-text">
                    Head of Household: {{ caseDetails.headOfHousehold }}
                  </div>
                  <div class="small tile-text">
                    Started By: {{ caseDetails.startedBy }}
                  </div>
                  <div class="small tile-text">
                    Started On: {{ caseDetails.startedOn | date: "MM/dd/yyyy" }}
                  </div>
                  <div class="small tile-text">
                    Last Accessed By: {{ caseDetails.lastAccessedBy }}
                  </div>
                  <div class="small tile-text">
                    Last Accessed On:
                    {{ caseDetails.lastAccessedOn | date: "MM/dd/yyyy" }}
                  </div>
                </div>
                }
              </div>
            </div>
          </div>
          <div
            class="card card-body shadow mb-2 p-3 p-md-4 d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start"
            [ngClass]="{ applyColor: selectedValue === 'new' }"
            (click)="select('new')"
          >
            <div class="row spl-margin ps-3">
              <img
                class="col dot"
                aria-hidden="true"
                alt=""
                src="../../../assets/images/Icons/Start_new_app.svg"
              />
            </div>
            <div class="flex-grow-1 min-w-0 w-100">
              <div class="section-column spl-padding">
                <strong class="tile_header"
                  >Start renewal from the beginning</strong
                >
                @if (caseDetails) {
                <div>
                  <div class="small tile-margin tile-text">
                    Case Number: {{ caseDetails.caseNumber }}
                  </div>
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row m-3">
      <button id="continue" class="col-md-2 btn btn-secondary" (click)="next()">
        {{ "NEXT" }}
      </button>
    </div>
  </div>
  }
</div>